export default __webpack_public_path__ + "static/media/porshia-bruise.e06f5629.jpg";